export default {
  common: {
    title: 'Logistik-Managementsystem',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    submit: 'Einreichen',
    reset: 'Zurücksetzen',
    search: 'Suchen',
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    save: 'Speichern',
    back: 'Zurück',
    operation: 'Aktion',
    status: 'Status',
    createTime: 'Erstellungszeit',
    updateTime: 'Aktualisierungszeit'
  },
  message: {
    success: 'Aktion erfolgreich',
    error: 'Aktion fehlgeschlagen',
    warning: 'Warnung',
    info: 'Hinweis',
    confirmDelete: 'Möchten Sie wirklich löschen?'
  },
  login: {
    title: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    loginBtn: 'Anmelden'
  },
  language: {
    language: 'Sprache',
    german: 'Deutsch',
    english: 'Englisch',
    chinese: 'Chinesisch',
    polish: 'Polnisch'
  },
  nav: {
    home: 'Startseite',
    about: 'Über',
    services: 'Dienstleistungen',
    blog: 'Blog',
    contact: 'Kontakt'
  },
  banner: {
    title1: 'Die beste Transportlösung weltweit',
    text1: 'Mehrere internationale Linien, direkte Luftfracht. Maximale Logistikrabatte, transparente Gebühren, keine versteckten Kosten.',
    title2: 'Die beste Transportlösung weltweit',
    text2: 'Durch präzise Abläufe ist die Effizienz 30%-40% höher als bei Mitbewerbern. Bedarfsgerecht nutzbar, jederzeit erweiterbar, vermeidet Lagerprobleme in der Hochsaison.',
    title3: 'Wegweisend bei globalen Logistikdienstleistungen',
    text3: 'Internationalen Handel vereinfachen.',
    requestQuote: 'Angebot anfordern'
  },
  tracking: {
    placeholder: 'Bitte geben Sie Ihre Logistik-Sendungsnummer ein',
    query: 'Abfragen',
    title: 'Logistikinformationen',
    noInfo: 'Keine Informationen',
    trackingNumber: 'Logistik-Sendungsnummer',
    loading: 'Logistikdaten werden geladen...',
    customerName: 'Empfänger',
    mobile: 'Telefon',
    address: 'Adresse',
    goodsName: 'Warenname',
    timelineTitle: 'Sendungsverlauf'
  },
  services: {
    title: 'Dienstleistungen',
    subtitle: 'Service für grenzüberschreitende E-Commerce-Verkäufer',
    description: 'Keine Sorge wegen der Lieferung, Bestellungen werden rechtzeitig bearbeitet.',
    landTransport: 'Landtransport',
    landTransportDesc: 'Niedrigste Rabatte für Internationalen Express, DHL, UPS und Postpakete, genießen Sie die niedrigsten Rabatte.',
    airFreight: 'Luftfracht',
    airFreightDesc: 'Bietet verschiedene direkte Lufttransportdienste nach Amerika, Europa, Japan und andere Regionen.',
    warehouse: 'Lager',
    warehouseDesc: 'Kostenlose Lagerung, einmalige Beauftragung, Lagerhaltung, Ausgang, Verpackung und Etikettierung.',
    seaFreight: 'Seefracht',
    seaFreightDesc: 'Zusammenführung hochwertiger internationaler Schifffahrtsressourcen aus Hongkong für weltweite Navigation.',
    homeDelivery: 'Hauslieferung',
    homeDeliveryDesc: 'Sie müssen nur eine bestimmte internationale Logistikgebühr bezahlen, wir liefern Ihre Waren direkt nach Hause.',
    support24x7: '24x7 Unterstützung',
    support24x7Desc: 'Jahre Erfahrung im grenzüberschreitenden E-Commerce-Service, 7*24 Stunden Online-Kundendienst, zeitzonenfreier Service.',
    readMore: 'Mehr lesen',
    bestServices: 'Unsere besten Dienstleistungen',
    bestServicesSubtitle: 'Wir bedienen Unternehmen, Geschäfte und Einzelpersonen, die im grenzüberschreitenden E-Commerce tätig sind.',
    internationalShipping: 'Internationale Schifffahrt',
    internationalShippingDesc: 'Größter Rabatt bei internationalen Logistikkosten, kann Ihnen helfen, Logistikkosten zu sparen.',
    packageProtection: 'Paketschutz',
    packageProtectionDesc: 'Dropshipping, Sortierung und Verpackung, Druck und Bestelletikettierung, Personalkosten sparen.',
    freightSupport: 'Frachtunterstützung',
    freightSupportDesc: 'Frachtunterstützung',
    onTimeDelivery: 'Pünktliche Lieferung',
    onTimeDeliveryDesc: '30% - 40% Höhere Betriebseffizienz als Mitbewerber, niedrige Fehlerrate und perfekte Benutzererfahrung.',
    logisticsWork: 'Logistikarbeit',
    logisticsWorkDesc: 'Kostenlose API zur effektiven Verwaltung von Lagerinformationen, Wareninformationen, Bestellinformationen und Logistikinformationen.',
    supportDesc: 'Bedarfsgerechte Nutzung des Lagerraums hilft Ihnen, die Probleme leerer Lager in der Nebensaison und überfüllter Lager in der Hochsaison zu vermeiden.',
    exploreAll: 'Alle Dienstleistungen erkunden'
  },
  about: {
    title: 'Über uns',
    mainTitle: 'Digitales und vertrauensvolles Transportunternehmen',
    description: 'GG ist ein neues Lagerservicemodell, das speziell für den export-orientierten E-Commerce entwickelt wurde, basierend auf Internet-Management.',
    point1: 'Kunden bringen Waren stapelweise ins Cloud-Lager;',
    point2: 'GG sortiert, verpackt, druckt und etikettiert Waren direkt aus dem Cloud-Lager basierend auf Verkaufsaufträgen und führt Transport und Verteilung durch;',
    description2: 'GG Enterprise Cloud-Lager ist ein umfassender Supply-Chain-Service, der Lagerverwaltung, internationalen Transport, Übersee-Zollabfertigung und Informationsmanagement integriert. Es kann Kunden helfen, Lager- und Logistikengpässe zu durchbrechen, Kosten zu sparen, die Kundenzufriedenheit zu erhöhen und Überseemärkte zu erschließen.',
    experience: 'Wir haben mehr als Jahre Erfahrung',
    readMore: 'Mehr lesen',
    contact: 'Kontakt'
  },
  choose: {
    title: 'Warum uns wählen',
    mainTitle: 'Wir bieten schnelle, bessere Lösungen für den Transport',
    description: 'Global Goods Enterprise Cloud-Lager ist ein neues Lagerservicemodell, das speziell für den export-orientierten E-Commerce entwickelt wurde, basierend auf Internet-Management. Es kann für Außenhandels-E-Commerce eine Komplettlösung aus Lagerhaltung, Sortierung und Verpackung, Dokumentendruck und Etikettierung, internationaler Logistik, Übersee-Distribution usw. anbieten und gleichzeitig ultra-niedrige internationale Versandkosten genießen. Hilft Kunden, Lager- und Logistikengpässe zu durchbrechen, Kosten zu sparen, die Kundenzufriedenheit zu erhöhen und Überseemärkte zu erschließen.',
    internationalShipping: 'International Versand',
    packageProtection: 'Paket Schutz',
    homeDelivery: 'Startseite Lieferung',
    deliveryTime: 'Liefertermin Zeit',
    contact: 'Kontakt'
  },
  team: {
    title: 'Unser Team',
    description: 'Jeder sagt das, aber in unserem Fall ist es wahr: Unser Team ist das Geheimnis unseres Erfolgs. Jeder Mitarbeiter ist ausgezeichnet, aber zusammen sind sie der Schlüssel dafür, dass Rostrum ein so interessanter und wertvoller Arbeitsplatz ist. Das Rostrum-Team ist ein eng verbundenes, talentiertes Team mit der gemeinsamen Vision, kontinuierlich hervorragende Ergebnisse für Kunden zu liefern und gleichzeitig sicherzustellen, dass das Unternehmen ein unterhaltsamer, inklusiver, herausfordernder Arbeitsplatz ist und Karrieren mit reichen Belohnungen entwickelt.',
    follow: 'Folgen'
  },
  gallery: {
    title: 'Unsere Galerie',
    description: 'Global Goods führt umfangreiche Geschäftsaktivitäten weltweit durch, wobei ihre sechs Geschäftsbereiche, eine Initiative und regionale Organisationen weltweit eng zusammenarbeiten. Durch strategische und organische Integration unserer soliden Geschäftsgrundlage und vielfältigen, hochrangigen Funktionen schaffen wir neue Werte, indem wir Veränderungen proaktiv angehen und bestehende Rahmen überschreiten, um bei der Lösung gesellschaftlicher Probleme zu helfen.',
    all: 'Alle',
    airFreight: 'Luftfracht',
    waterFreight: 'Wasserfracht',
    shipping: 'Versand',
    shippingTitle: 'Versand',
    expertTeam: 'Expertenteam',
    expertMember: 'Expertenmitglied',
    carTransport: 'Autotransport',
    seaport: 'Seehafen',
    container: 'Container',
    packaging: 'Verpackung'
  },
  funfact: {
    productDelivery: 'Produktlieferung',
    totalBranches: 'Gesamte Niederlassungen',
    satisfiedCustomers: 'Zufriedene Kunden',
    ownVehicles: 'Eigene Fahrzeuge'
  },
  blog: {
    title: 'Neueste Nachrichten & Blog',
    description: 'Finden Sie die neuesten Blog-Nachrichten von WIRED. Sehen Sie verwandte Artikel, Fotos, Diashows und Videos.',
    readMore: 'Mehr lesen',
    comments: 'Kommentare',
    title1: 'Luftfracht kann während der Pandemie teuer werden',
    excerpt1: 'Drastisch reduzierte Versandkapazität und dringende Nachfrage nach Schutzausrüstung haben die Preise für Luftfrachtdienste in die Höhe getrieben ...',
    title2: 'Neue Frachtsendung ist auf dem globalen Markt geöffnet',
    excerpt2: 'An der Spitze dieses Marktes müssen sich globale Spediteure verpflichten, eine flexible Haltung beim Transport von Waren beizubehalten. Offen bleiben für Neues ...',
    title3: 'Transportgebühren wurden entfernt von',
    excerpt3: 'Aufgrund der direkten Auswirkung des Transports auf den wirtschaftlichen Erfolg sind Regierungen traditionell mehr in die Praktiken der Spediteure involviert als in den meisten Fällen ...'
  },
  transport: {
    title: 'Transport',
    mainTitle: 'Bringen Sie Ihre Waren überall hin',
    description: 'Referenz-Zeitlimit: Bezieht sich auf die normale Transportzeit von Waren. Das heißt, basierend auf Big-Data-Berechnungen können die meisten Pakete aufgrund von Wetter, Zollkontrollen, Hafenstaus, Logistiklager-Explosionen und anderen Problemen verzögert werden, von der Netzwerk-Zugriffs-Abfragezeit bis zur Ankunft der Waren am Bestimmungsort. Die spezifische Situation unterliegt dem tatsächlichen Transport.',
    requestQuote: 'Angebot anfordern',
    formTitle: 'Angebot anfordern',
    name: 'Name',
    request: 'Angebot anfordern',
    length: 'Angebot anfordern (CM)',
    width: 'Breite (CM)',
    weight: 'Gewicht (KG)',
    distance: 'Entfernung (KM)',
    city: 'Stadt',
    transportType: 'Transportart',
    airFreight: 'Luftfracht',
    roadTransport: 'Straßentransport',
    railTransport: 'Bahntransport',
    seaFreight: 'Seefracht',
    submit: 'Jetzt einreichen',
    contact: 'Kontakt'
  },
  newsletter: {
    title: 'Bleiben Sie mit unserem neuesten Newsletter auf dem Laufenden',
    placeholder: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    subscribe: 'Abonnieren'
  },
  footer: {
    followUs: 'Folgen Sie uns',
    quickLinks: 'Schnelle Links',
    about: 'Über',
    services: 'Dienstleistungen',
    currentWork: 'Aktuelle Arbeiten',
    expertTeam: 'Expertenteam',
    newsBlog: 'Nachrichten & Blogs',
    support: 'Unterstützung',
    faqs: "FAQ's",
    pricing: 'Preisgestaltung',
    privacyPolicy: 'Datenschutzrichtlinie',
    terms: 'Geschäftsbedingungen',
    globalLocations: 'Globale Standorte',
    partners: 'Unsere Partner',
    copyright: 'Copyright @2024 fairy. Designed By',
    menu: 'Menü'
  }
}
